// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Your Firebase configuration
// Replace these values with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA7qzKJuI1Sf24AFCftMMAYhwun8bHGLLY",

  authDomain: "infinitywhale-5bedb.firebaseapp.com",

  projectId: "infinitywhale-5bedb",

  storageBucket: "infinitywhale-5bedb.firebasestorage.app",

  messagingSenderId: "1051977318381",

  appId: "1:1051977318381:web:f4edcba3ecda1d3316f1e4",

  measurementId: "G-9LS2WXJCLN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// MOVE THIS AFTER googleProvider is created
googleProvider.setCustomParameters({
  prompt: "select_account", // This forces Google to show account selection every time
});

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Functions
export const functions = getFunctions(app);

// Connect to local emulator only during local development
if (window.location.hostname === "localhost" && window.location.port === "3000") {
  try {
    connectFunctionsEmulator(functions, "localhost", 5001);
    console.log("Connected to Functions emulator");
  } catch (error) {
    console.log("Functions emulator already connected or not available");
  }
} else {
  console.log("Using production Firebase Functions");
}

// Export httpsCallable for calling functions
export { httpsCallable };

export default app;
